// Pedido desde el minisitio (/app/<slug>) de un negocio de pedidos: carrito, validación del formulario y textos de error.
// El precio y el total los vuelve a calcular la base (create_public_order); aquí solo se muestran.

export const PAYMENT_OPTIONS = [
  { value: 'efectivo', label: 'Efectivo', hint: 'Pagas al recibir el pedido' },
  { value: 'transferencia', label: 'Transferencia', hint: 'Pagas por transferencia a la cuenta del negocio' }
];

export const setCartQty = (cart, id, qty) => {
  const n = Math.min(Math.max(Math.floor(Number(qty) || 0), 0), 50);
  const rest = cart.filter((l) => l.id !== id);
  return n > 0 ? [...rest, { id, cantidad: n }].sort((a, b) => String(a.id).localeCompare(String(b.id))) : rest;
};

export const cartQty = (cart, id) => cart.find((l) => l.id === id)?.cantidad || 0;

export const cartTotal = (cart, products) => cart.reduce((sum, l) => sum + l.cantidad * (Number(products.find((p) => p.id === l.id)?.precio) || 0), 0);

export function validateOrderForm({ name, phone, city, address, payment }, { cities = [], cart = [] } = {}) {
  if (!cart.length) return { ok: false, error: 'Elige al menos un producto.' };
  if (String(name ?? '').trim().length < 2) return { ok: false, error: 'Escribe tu nombre.' };
  const digits = String(phone ?? '').replace(/\D/g, '');
  if (digits.length < 10 || digits.length > 15) return { ok: false, error: 'Escribe tu celular con 10 dígitos (ej: 300 123 4567).' };
  if (cities.length > 0 && !cities.includes(city)) return { ok: false, error: 'Elige tu ciudad.' };
  if (String(address ?? '').trim().length < 5) return { ok: false, error: 'Escribe la dirección de entrega (barrio, calle y número).' };
  if (!PAYMENT_OPTIONS.some((o) => o.value === payment)) return { ok: false, error: 'Elige cómo vas a pagar.' };
  return { ok: true };
}

const ERRORS = {
  pedidos_no_disponibles: 'Este negocio no está recibiendo pedidos por la página en este momento.',
  nombre_invalido: 'Revisa tu nombre.',
  telefono_invalido: 'Revisa tu celular.',
  direccion_invalida: 'Revisa la dirección de entrega.',
  ciudad_invalida: 'Esa ciudad no está en la cobertura. Elige una de la lista.',
  medio_de_pago_invalido: 'Elige cómo vas a pagar.',
  pedido_vacio: 'Elige al menos un producto.',
  producto_no_disponible: 'Un producto ya no está disponible. Actualiza la página y vuelve a armar el pedido.',
  demasiados_pedidos: 'Ya hiciste varios pedidos seguidos. Espera un rato o escríbenos por WhatsApp.',
  servicio_ocupado: 'Estamos recibiendo muchos pedidos. Intenta en unos minutos o escríbenos por WhatsApp.'
};

export function publicOrderError(error) {
  const text = `${error?.message || ''} ${error?.details || ''}`;
  const stock = text.match(/sin_existencias:([^\n]*)/);
  if (stock) return `No tenemos existencias suficientes de ${stock[1].trim()}. Baja la cantidad o escríbenos por WhatsApp.`;
  const known = Object.keys(ERRORS).find((k) => text.includes(k));
  if (known) return ERRORS[known];
  if (error?.code === 'PGRST202' || error?.code === '42883') return 'Los pedidos por la página aún no están activados. Escríbenos por WhatsApp.';
  return 'No se pudo enviar el pedido. Intenta de nuevo o escríbenos por WhatsApp.';
}

// Mensaje para que el cliente envíe el comprobante o consulte por su pedido.
export const whatsappLink = (phone, text) => {
  const digits = String(phone ?? '').replace(/\D/g, '');
  return digits ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}` : '';
};
